import _get from 'lodash/get';
import _has from 'lodash/has';
export function getChildFilters(state, value, list) {
  if (list === void 0) {
    list = [];
  }
  const childFilters = Object.keys(state).filter(key => {
    const delimiter = '|';
    const [, secondStr, ...rest] = key.split(delimiter);
    return secondStr && [secondStr, [secondStr, ...rest].join(delimiter)].includes(value);
  });
  if (childFilters.length > 0) {
    // Push values to the list
    list = list.concat(childFilters);
    childFilters.forEach(childFilter => {
      const childFilterValue = state[childFilter].value;
      if (Array.isArray(childFilterValue)) {
        childFilterValue.forEach(val => {
          list = list.concat(getChildFilters(state, val, list));
        });
      } else {
        list = list.concat(getChildFilters(state, childFilterValue, list));
      }
    });
  }

  // De-dupe the list of child filters
  return list.reduce((acc, cv) => {
    if (!acc.includes(cv)) {
      acc.push(cv);
    }
    return acc;
  }, []);
}
export function selectFilter(state, payload) {
  const {
    value,
    filter,
    isMultiple
  } = payload;
  let newValue = value;
  if (isMultiple) {
    const currentValue = _get(state, [filter.name, 'value'], []);
    // concat current value and new to an array to ensure an array
    // generate new set to remove any duplicate values
    // convert Set to an array by spreading it
    newValue = [].concat(currentValue, value).filter((item, index, arr) => arr.indexOf(item) >= index);
  }
  const updatedFilter = {
    ...state[filter.name],
    value: newValue
  };

  // Protect filter value if filter is protected
  if (filter.protected) {
    updatedFilter.protected = true;
  }
  return {
    ...state,
    [filter.name]: updatedFilter
  };
}
export function setFilterTouched(state, filterName) {
  return {
    ...state.touched,
    [filterName]: true
  };
}
export function applyFilterGroups(payload) {
  const hasGroups = Object.prototype.hasOwnProperty.call(payload, 'filters') || Object.prototype.hasOwnProperty.call(payload, 'filterGroups');
  if (hasGroups) {
    const {
      filters = {},
      filterGroups = {},
      ...rest
    } = payload;
    const updatedFilters = {
      ...filters,
      ...rest
    };

    // Prepare MultiFilters/FilterGroups with '|' delimited names
    Object.keys(filterGroups).forEach(filterGroupKey => {
      const filterGroup = {};
      Object.keys(filterGroups[filterGroupKey]).forEach(filterKey => {
        const filter = {
          ...filterGroups[filterGroupKey][filterKey]
        };

        // Build and update new pipe-delimited name from group and key
        filter.name = [filterGroupKey, filterKey].join('|');

        // set filter to filter group under updated name
        filterGroup[filter.name] = filter;
      });
      updatedFilters[filterGroupKey] = filterGroup;
    });
    return updatedFilters;
  }
  return payload;
}
export function getBreadcrumbValueKey(filterKey, values) {
  if (_has(values, filterKey)) {
    return filterKey;
  }

  // if a value isn't present then we will check to see if the breadcrumb key is part of of a multi-filter set
  return Object.keys(values).find(key => {
    const regex = RegExp(`^${filterKey}`, 'i');
    return regex.test(key);
  }) || null;
}
export function getBreadcrumbData(filterKey, values, labelsByValues) {
  const valuesKey = getBreadcrumbValueKey(filterKey, values);

  // get value from values
  let value = _get(values, [valuesKey], null);

  // reduce any possible value array to a single string value
  [value] = [].concat(value);

  // get the label (human value) from the labelsByValues map
  // if it doesn't exist then it will a user defined input and we return null for label
  const label = _get(labelsByValues, [valuesKey, value], null);
  return {
    filterKey,
    label,
    value,
    valuesKey
  };
}
export function getLabelValuePairs(options) {
  if (options === void 0) {
    options = [];
  }
  return options.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {});
}